import * as React from 'react';
import { Button, Col, Form, Input, Row, message } from 'antd';
import { FormItemProps, FormComponentProps } from 'antd/lib/form';
import { RouteComponentProps } from 'react-router';
import I18N from 'src/services/I18NService';
import WalletService, { IAccountInfo,IApplyBindCardParam, EAccountMemberType } from 'src/services/WalletService';
import { RouterConfig } from 'src/routers/urlConfig';




interface IWalletBindCardPageProps extends FormComponentProps, RouteComponentProps {}

interface IWalletBindCardPageState {
  /** 是否正在提交 */
  isLoading: boolean;
  account: IAccountInfo;
}

class WalletBindCardForm extends React.Component<IWalletBindCardPageProps, IWalletBindCardPageState> {
  private walletService = WalletService;
  /** 流水号(验证码接口返回) */
  // private transNo = '';
  // private iframe: HTMLIFrameElement | null;
  constructor(props: IWalletBindCardPageProps) {
    super(props);
    this.state = {} as IWalletBindCardPageState;
  }

  async componentDidMount() {
    let accounts = this.walletService.accountInfo;
    if (accounts.length === 0) {
      // 刷新时丢失accounts信息， 重新调用接口获取
      accounts = await this.walletService.getAccounts();
    }
    // 获取个人账户
    const account = accounts.find(accountItem => accountItem.member_type === EAccountMemberType.Individual);
    if (!!account) {
      this.setState({ account, isLoading: false });
    }
  }

  /**
   * 请求绑卡提交
   */
  bindCard = (e: React.SyntheticEvent) => {
    e.preventDefault();
    this.props.form.validateFields(async (err, values) => {
      if (!err) {
        const { account } = this.state;
        if (!!account) {
          const param: IApplyBindCardParam = {
            card_no: values.card_no,
            name: account.name as string,
            identity_no: account.identity_no as string,
            identity_type: account.identity_type as number,
            phone: values.phone,
          }
          this.setState({ isLoading: true });
          const accountId = account.id as string;
          const res = await this.walletService.applyBindCard(accountId, param);
          this.setState({ isLoading: false });
          if (!!res && !!res.card_no) {
            message.success('绑卡成功');
            this.goback();
          }
        }
        
        
        

        // if (!this.transNo) {
        //   message.error('动态验证码不符(N5C0048)');
        // } else {
        //   const param: IConfirmBindCardParam = {
        //     card_no: values.card_no,
        //     phone: values.phone,
        //     trans_no: this.transNo,
        //     verification_code: values.verification_code,
        //   }
        //   this.setState({ isLoading: true });
        //   const accountId = this.state.account.id as string;
        //   const res = await this.walletService.confirmBindCard(accountId, param);
        //   this.setState({ isLoading: false });
        //   if (!!res && !!res.card_no) {
        //     message.success('绑卡成功');
        //     this.goback();
        //   }
        // }
      }
    });
    
  }

  // /**
  //  * 发送验证码
  //  * @param data 
  //  */
  // async verifyCode(data: IVerificationCode) {
  //   this.props.form.validateFields(['name', 'card_no', 'phone'], async (err) => {
  //     if (!err) {
  //       this.transNo = '';
  //       const { account } = this.state;
  //       if (data.mobile && account) {
  //         const param: IApplyBindCardParam = {
  //           card_no: this.props.form.getFieldValue(`card_no`),
  //           phone: data.mobile,
  //           name: account.name as string,
  //           identity_no: account.identity_no as string,
  //           identity_type: account.identity_type as number,
  //         };
  //         const accountId = account.id as string;
  //         const res = await this.walletService.applyBindCard(accountId, param);
  //         if (!!res && !!res.trans_no) {
  //           this.transNo = res.trans_no;
  //           message.success(I18N.get('login_get_verify'));
  //         }
  //       }
  //     }
  //   })
  // }

  private goback() {
    this.props.history.push(RouterConfig.Urls.wallet);
  }

  render() {
    const { isLoading, account } = this.state;
    if (!account) {
      return (<div/>);
    }
    const { getFieldDecorator } = this.props.form;
    const formItemLayout: FormItemProps = {
      labelCol: { span: 6 },
      wrapperCol: { span: 8 },
    };
    const tailFormItemLayout: FormItemProps = {
      wrapperCol: { span: 8, offset: 6 },
    };

    return (
      <div>
        <div style={{ margin: 12 }} className="clearfix">
          <span style={{ float: 'left', lineHeight: '32px', color: '#1fb8cd' }}>{'绑定银行卡'}</span>
          <Button type="primary" onClick={() => this.goback()} style={{ float: 'right' }}>
            {I18N.get('common_back')}
          </Button>
        </div>
        <Row gutter={24} type="flex" justify="center" style={{ marginTop: 60 }}>
          <Col span={16} offset={4}>
            <Form onSubmit={this.bindCard}>
              <Form.Item label={I18N.get('common_name')} {...formItemLayout}>
                {getFieldDecorator(`name`, {
                  rules: [
                    {
                      required: true,
                      message: `${I18N.get('common_input')}${I18N.get('common_name')}`,
                    },
                  ],
                  initialValue: account.name || null,
                })(<Input disabled={true} placeholder={`${I18N.get('common_input')}${I18N.get('common_mobile')}`} />)}
              </Form.Item>
              <Form.Item label={'卡号'} {...formItemLayout}>
                {getFieldDecorator(`card_no`, {
                  rules: [
                    {
                      required: true,
                      message: '请输入开户卡号',
                    },
                    {
                      pattern: /^[0-9]+$/ig,
                      message: '开户卡号格式错误',
                    },
                  ],
                })(<Input />)}
              </Form.Item>
              <Form.Item label={'预留手机'} {...formItemLayout}>
                {getFieldDecorator(`phone`, {
                  rules: [
                    {
                      required: true,
                      message: '请输入预留手机号'
                    },
                    {
                      pattern: /^((13)|(14)|(15)|(16)|(17)|(18)|(19))\d{9}$/ig,
                      message: I18N.get('err_mobile'),
                    },
                  ],
                  initialValue: account.phone || null,
                })(<Input />)}
              </Form.Item>
              {/* <Form.Item label={I18N.get('login_verify_code')} {...formItemLayout}>
                {getFieldDecorator('verification_code', {
                  rules: [
                    {
                      required: true,
                      message: `${I18N.get('common_input')}${I18N.get('login_verify_code')}`,
                    },
                    {
                      pattern: /^[0-9]{6}$/ig,
                      message: '验证码格式错误',
                    },
                  ],
                })(<Input
                      placeholder={`${I18N.get('common_input')}${I18N.get('login_verify_code')}`}
                      suffix={
                        <TencentCaptchaButton
                          isDomestic={true}
                          phoneOrEmail={this.props.form.getFieldValue(`phone`)}
                          onSend={(data) => this.verifyCode(data)}/>
                      } />)}
              </Form.Item> */}
              {/* <Form.Item {...tailFormItemLayout}>
                {getFieldDecorator('agreement', {
                  valuePropName: 'checked',
                })(
                  <Checkbox>
                    我已阅读并同意相关<a href="">绑卡服务协议</a>
                  </Checkbox>,
                )}
              </Form.Item> */}
              <Form.Item {...tailFormItemLayout}>
                <Button type="primary" htmlType="submit" loading={isLoading}>
                  提交
                </Button>
              </Form.Item>
            </Form>
          </Col>
        </Row>
      </div>
    );
  }
}

const WalletBindCardPage = Form.create<IWalletBindCardPageProps>()(WalletBindCardForm);
export default WalletBindCardPage;



// WEBPACK FOOTER //
// ./src/components/views/Wallet/WalletBindCardPage.tsx